<div class="filter-all">
  <div class="filter-top">
    <div class="filter-header">
      <button mat-icon-button class="close-filter" (click)="sendClose()">
        <mat-icon>close</mat-icon>
      </button>
      <div fxFlex="" class="filter-title" translate="">Filters</div>
      <button
        class="delete-button"
        mat-flat-button
        (click)="tag_list.deselectAll(); removeAllFilters()"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        {{ 'Delete' | translate }}
      </button>
    </div>
  </div>
  <div style="width: 100%" class="scroll-filter">
    <mat-form-field class="location-chip" appearance="fill">
      <mat-label translate="">SearchPlace</mat-label>
      <mat-chip-list #chipList class="chip-list-sp">
        <mat-chip
          *ngFor="let chip of secondChipInputList"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeSecondaryFilterChip(chip)"
        >
          {{ chip }}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="{{ 'searchPlaceHolder' | translate }}"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addFilterChip($event)"
        />
        <mat-icon matSuffix>location_on</mat-icon>
      </mat-chip-list>
    </mat-form-field>
    <button
      *ngIf="
        tag_list.selectedOptions.selected.length > 0 ||
        this.maxValueElevation < 1000 ||
        this.minValueElevation > 0 ||
        this.maxValue < 60 ||
        this.minValue > 0 ||
        this.isLoop != undefined ||
        this.isLinear != undefined ||
        this.difficultyValue ||
        this.isCdesi != false ||
        this.disabledAccess != false ||
        this.sortieNature != false
      "
      mat-icon-button
      class="delete-filters"
      (click)="tag_list.deselectAll(); removeAllFilters(); filterByTag()"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <div
      id="divChip"
      class="chip-form-div {{
        removeMinHeight ? 'chip-expanded' : 'chip-reduced'
      }}"
    >
      <mat-form-field class="chip-form-field">
        <mat-chip-list
          #chipList
          class="{{ isSp ? 'chip-list-sp' : '' }}"
          role="listbox"
        >
          <!-- ? Search filter element chipss ? -->
          <mat-chip
            *ngFor="let chip of mainChipInputList"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="removeMainFilterChip(chip)"
            (click)="removeMainFilterChip(chip)"
          >
            {{ chip }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <!-- ? Real tags ?s -->
          <mat-chip
            class="chip chip-tag"
            *ngFor="let tag of tag_list.selectedOptions.selected"
            role="option"
            (click)="tag_list.selectedOptions.deselect(tag); filterByTag()"
          >
            <span class="chip-text">{{ tag.value?.name | translate }}</span>
            <mat-icon>close</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </mat-form-field>
      <button
        *ngIf="seeExpand"
        mat-mini-fab
        class="expand-chip"
        color="warn"
        (click)="toggleRemoveMinHeight()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <!-- Filter tree -->
    <mat-selection-list
      #tag_list
      class="filter-select-list"
      role="listbox"
      [(ngModel)]="checkedList"
      (selectionChange)="filterByTag()"
    >
      <mat-accordion class="filters" multi displayMode="flat">
        <mat-expansion-panel
          #catPanel
          class="filter-tag-list"
          hideToggle
          disabled
          [expanded]="
            subCatId ? cat?.cat.subCatId == subCatId : cat?.cat.catId == catId
          "
          *ngFor="let cat of catId == undefined ? tagNested : getCatNode()"
        >
          <mat-expansion-panel-header>
            <mat-panel-title
              class="filter-main-title"
              (click)="
                cat?.children.length > 0 || cat?.cat.catId == '3'
                  ? catPanel.toggle()
                  : ''
              "
            >
              <mat-icon
                color="primary"
                svgIcon="{{ getIconRef(cat) }}"
              ></mat-icon>
              <mat-icon
                class="expand-chevron"
                *ngIf="cat?.children.length > 0 || cat?.cat.catId == '3'"
                >{{
                  catPanel.expanded ? 'expand_more' : 'chevron_right'
                }}</mat-icon
              >
              <mat-icon
                class="expand-chevron"
                *ngIf="cat?.cat.catId == '4'"
              ></mat-icon>
              {{ getSubCategTitle(cat?.cat.name) | translate }}
            </mat-panel-title>
            <mat-panel-description>
              <mat-list-option
                *ngIf="catId == undefined && subCatId == undefined"
                #check
                disableRipple
                [value]="cat?.cat"
                [selected]="isCheckboxSelected(cat?.cat.name)"
                ng-checked="true"
              ></mat-list-option>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- AGENDA FILTERS -->
          <mat-divider style="margin: 10px 0px 3px 13px"></mat-divider>
          <div>
            <span
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              class="calendar-label"
            >
              Calendrier
            </span>
            <button
              mat-icon-button
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              (click)="resetDateRange()"
              class="reset-date-range {{
                (startDate.value != null && startDate.value != '') ||
                (endDate.value != null && endDate.value != '')
                  ? 'visible'
                  : 'not-visible'
              }}"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <div
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              class="date-picker-div"
            >
              <mat-form-field class="example-full-width" appearance="fill">
                <input
                  matInput
                  [matDatepicker]="startDatePicker"
                  placeholder="Date de début"
                  [formControl]="startDate"
                  (dateChange)="filterByTag()"
                  (focus)="startDatePicker.open()"
                  readonly
                />
                <mat-datepicker #startDatePicker></mat-datepicker>
                <mat-error *ngIf="startDate.hasError('matStartDateInvalid')"
                  >Date invalide</mat-error
                >
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="fill">
                <input
                  matInput
                  [matDatepicker]="endDatePicker"
                  placeholder="Date de fin"
                  [formControl]="endDate"
                  (dateChange)="filterByTag()"
                  (focus)="endDatePicker.open()"
                  readonly
                />
                <mat-datepicker #endDatePicker></mat-datepicker>
                <mat-error *ngIf="endDate.hasError('matEndDateInvalid')"
                  >Date invalide</mat-error
                >
              </mat-form-field>
            </div>
            <mat-divider
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              style="margin: 10px 0px 0px 1px"
            ></mat-divider>
            <div
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              class="sortie-nature-filter"
            >
              <p>Sortie nature</p>
              <mat-checkbox
                disableRipple
                value="Sortie nature"
                [checked]="isSortieNatureCheckboxSelected()"
                (change)="handleSortieNatureValue()"
              ></mat-checkbox>
            </div>
            <mat-divider
              *ngIf="cat?.cat.catId == '3' && !subCatId"
              style="margin: 0px 0px 0px 1px"
            ></mat-divider>
          </div>
          <!-- AGENDA FILTERS END -->

          <!-- CIRCUIT FILTERS -->
          <div *ngIf="cat?.cat.catId == '1'">
            <div class="slider-radio">
              <p class="subcat-circuit-titles" style="font-weight: bold">
                Modes de déplacement
              </p>
            </div>
          </div>
          <!-- CIRCUIT FILTERS END -->
          <!-- SUBCATEGORIES GENERIC FILTERS LOOP -->
          <mat-accordion
            class="filters inner-filter"
            multi
            displayMode="flat"
            *ngIf="cat?.children.length > 0"
          >
            <mat-expansion-panel
              #panel
              *ngFor="let subCat of cat?.children"
              disabled
              [expanded]="subCat?.cat.subCatId == subCatId"
              [ngClass]="{ 'edit-border': subCat.cat.name === 'Label bio AB' }"
            >
              <mat-expansion-panel-header>
                <mat-panel-title
                  (click)="subCat.children.length > 0 ? panel.toggle() : ''"
                >
                  <mat-icon
                    class="expand-chevron"
                    *ngIf="subCat?.children.length > 0"
                    >{{
                      panel.expanded ? 'expand_more' : 'chevron_right'
                    }}</mat-icon
                  >
                  <!-- TODO UPDATE CSS MIN -->
                  <p>{{ getSubCategTitle(subCat.cat.name) | translate }}</p>
                </mat-panel-title>
                <mat-panel-description>
                  <mat-list-option
                    #check
                    disableRipple
                    [value]="subCat.cat"
                    [selected]="isCheckboxSelected(subCat?.cat.name)"
                    [disabled]="
                      cat?.cat.catId == '3' &&
                      ((endDate.value != null && endDate.value != '') ||
                        (startDate.value != null && startDate.value != ''))
                        ? true
                        : false
                    "
                  ></mat-list-option>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-accordion
                class="filters"
                multi
                *ngIf="subCat.children.length > 0"
              >
                <mat-expansion-panel
                  *ngFor="let tag of subCat.children"
                  disabled
                  [ngClass]="{ 'edit-border': tag.cat.name === 'Label bio AB' }"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>{{
                      tag.cat.name | translate
                    }}</mat-panel-title>
                    <mat-panel-description>
                      <mat-list-option
                        #check
                        disableRipple
                        [value]="tag.cat"
                        [selected]="isCheckboxSelected(tag?.cat.name)"
                      ></mat-list-option>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-expansion-panel>
          </mat-accordion>
          <!-- SUBCATEGORIES GENERIC FILTERS LOOP END -->

          <!-- CIRCUIT FILTERS -->
          <div *ngIf="cat?.cat.catId == '1'">
            <div class="slider-radio">
              <!-- DISTANCE // DUREE -->
              <mat-button-toggle-group
                (change)="toggleCircuitFilter()"
                name="fontStyle"
                aria-label="Font Style"
              >
                <mat-button-toggle
                  class="subcat-circuit-titles"
                  [checked]="isDist"
                  value="dist"
                  >{{ 'FilterByDist' | translate }}</mat-button-toggle
                >
                <mat-button-toggle
                  class="subcat-circuit-titles"
                  [checked]="!isDist"
                  value="time"
                  >{{ 'FilterByDuration' | translate }}</mat-button-toggle
                >
              </mat-button-toggle-group>
              <div class="slider-info">
                {{
                  isDist
                    ? minSlideDistValue(minValue)
                    : getDurationStringified(minValue)
                }}
                -
                {{
                  isDist
                    ? minSlideDistValue(maxValue)
                    : getDurationStringified(maxValue)
                }}
              </div>
              <ngx-slider
                [(value)]="minValue"
                [(highValue)]="maxValue"
                [options]="options"
                (userChangeEnd)="handleCircuitDistDurationFilter()"
              ></ngx-slider>
              <!-- DISTANCE // DUREE END -->

              <!-- DENIVELE -->
              <mat-divider style="margin: 10px 0px 0px 1px"></mat-divider>
              <div class="slider-info slider-info-denivele">
                {{ slideElevationValue(minValueElevation) }} -
                {{ slideElevationValue(maxValueElevation) }}
              </div>
              <p class="subcat-circuit-titles subcateg-capitalize">
                {{ 'FilterByElevation' | translate }}
              </p>
              <ngx-slider
                [(value)]="minValueElevation"
                [(highValue)]="maxValueElevation"
                [options]="optionsElevation"
                (userChangeEnd)="handleElevationFilter()"
              ></ngx-slider>
              <!-- DENIVELE END -->

              <!-- DIFFICULTY -->
              <mat-divider style="margin: 10px 0px 0px 1px"></mat-divider>
              <p class="subcat-circuit-titles" style="font-weight: bold">
                {{ 'Difficulty' | translate }}
              </p>
              <div aria-label="Niveaux de difficulté" class="tag-div">
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: checkDifficultyValue(1)
                  }"
                  (click)="setDifficultyValue(1, 'TRES FACILE')"
                  value="1"
                >
                  <mat-icon
                    [ngClass]=""
                    aria-hidden="true"
                    svgIcon="circuit_difficulty_1"
                  ></mat-icon>
                  <span translate="">VeryEasy</span>
                </div>
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: checkDifficultyValue(2)
                  }"
                  (click)="setDifficultyValue(2, 'FACILE')"
                  value="2"
                >
                  <mat-icon
                    [ngClass]=""
                    aria-hidden="true"
                    svgIcon="circuit_difficulty_2"
                  ></mat-icon>
                  <span translate="">Easy</span>
                </div>
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: checkDifficultyValue(3)
                  }"
                  (click)="setDifficultyValue(3, 'MOYEN')"
                  value="3"
                >
                  <mat-icon
                    [ngClass]=""
                    aria-hidden="true"
                    svgIcon="circuit_difficulty_3"
                  ></mat-icon>
                  <span translate="">Medium</span>
                </div>
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: checkDifficultyValue(4)
                  }"
                  (click)="setDifficultyValue(4, 'DIFFICILE')"
                  value="4"
                >
                  <mat-icon
                    [ngClass]=""
                    aria-hidden="true"
                    svgIcon="circuit_difficulty_4"
                  ></mat-icon>
                  <span translate="">Hard</span>
                </div>
              </div>
              <!-- DIFFICULTY END -->

              <!-- CIRCUIT TYPE -->
              <mat-divider style="margin: 10px 0px 0px 1px"></mat-divider>
              <p class="subcat-circuit-titles" style="font-weight: bold">
                {{ 'TypeOfCircuit' | translate }}
              </p>
              <div aria-label="Boucle ou itinéraire" class="tag-div">
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: getLinearValue()
                  }"
                  (click)="setLinearValue()"
                >
                  <img
                    class="img-loop img-linear"
                    src="assets/icons/icon_lineaire.png"
                    aria-hidden="true"
                  />
                  <span translate="">Linear</span>
                </div>
                <div
                  [ngClass]="{
                    'mat-button tag filters-only': true,
                    selected: getLoopValue()
                  }"
                  (click)="setLoopValue()"
                  value="1"
                >
                  <img
                    class="img-loop"
                    src="assets/icons/icon_loop.png"
                    aria-hidden="true"
                  />
                  <span translate="">Loop</span>
                </div>
              </div>
              <!-- CIRCUIT TYPE END -->

              <!-- CDESI -->
              <mat-divider style="margin: 10px 0px 8px 13px"></mat-divider>
              <div class="cdesi-slider" *ngIf="cat?.cat.catId == '1'">
                <mat-slide-toggle
                  [checked]="isCdesiCheckboxSelected()"
                  (change)="handleCdesiValue()"
                ></mat-slide-toggle>
                <span class="cdesi-title">Labellisé Sport de Nature</span>
                <p class="cdesi-subtext">
                  Label départemental accordé aux circuits répondant à une
                  logique de développement durable (respect de l’environnement,
                  sécurité des usagers) et présentant un intérêt sportif et une
                  qualité de paysages
                </p>
              </div>
              <!-- CDESI END -->
            </div>
          </div>
          <!-- CIRCUIT FILTERS END -->
        </mat-expansion-panel>

        <!-- PMR FILTER -->
        <div class="disabled-access slider-radio">
          <mat-divider style="margin: 0px 0px 13px 13px"></mat-divider>
          <mat-slide-toggle
            [checked]="isPMRCheckboxSelected()"
            (change)="setPMRValue()"
          ></mat-slide-toggle>
          <a>Accessibilité PMR</a>
        </div>
        <!-- PMR FILTER END -->
      </mat-accordion>
    </mat-selection-list>
  </div>

  <!-- FOOTER-FILTER  -->
  <div class="filter-footer">
    <!-- MORE-FILTER  -->
    <div class="more-filter">
      <p>
        Vous ne trouvez pas ce que vous cherchez ?
        <a routerLink="/carte">Accédez à tous les filtres</a>
      </p>
    </div>
    <!-- MORE-FILTER  -->

    <!-- VALIDATE-FILTER  -->
    <div class="validate-filter" *ngIf="!isMobile">
      <button
        mat-raised-button
        color="accent"
        class="filter-button"
        (click)="updateFilter()"
      >
        {{
          'ShowResult'
            | translate : { value: cards != undefined ? cards.length : 0 }
        }}
        <mat-icon>location_on</mat-icon>
      </button>
    </div>
    <div class="validate-filter-mobile" *ngIf="isMobile">
      <div>
        <button
          mat-raised-button
          color="accent"
          class="filter-button"
          (click)="updateFilter()"
        >
          {{
            'ShowResult'
              | translate : { value: cards != undefined ? cards.length : 0 }
          }}
          <mat-icon>location_on</mat-icon>
        </button>
      </div>
    </div>
    <!-- VALIDATE-FILTER  -->
  </div>
  <!-- FOOTER-FILTER  -->
</div>
